import { query } from "./strapi";
import { submitFormData } from "./getForms"; // Import the existing form submission function

export async function getPartnerHome() {
  const res = await query("partner-home");

  if (!res) {
    throw new Error("Failed to fetch partner home data");
  }

  // Transform the form structure to match the expected format
  if (res.form) {
    // Make sure sections are properly formatted
    res.form.sections = res.form.sections.map((section: any) => {
      // Transform field properties to match the FormField interface in PartnersPage.tsx
      const fields =
        section.fields?.map((field: any) => {
          // Map from 'name' to 'slug' if needed
          if (field.name && !field.slug) {
            field.slug = field.name;
          }

          // Map from 'required' to 'isRequired' if needed
          if (field.required !== undefined && field.isRequired === undefined) {
            field.isRequired = field.required;
          }

          return {
            ...field,
            // Ensure consistent field structure
            id: field.id || Math.random(),
            order: field.order || 0,
          };
        }) || [];

      return {
        ...section,
        fields,
        // Ensure consistent section structure
        id: section.id || Math.random(),
        order: section.order || 0,
      };
    });

    // Ensure form has needed properties
    res.form = {
      ...res.form,
      isActive: res.form.isActive !== false, // Default to true if not specified
    };
  }

  console.log("Transformed partner home data:", res); // Debug log
  return res;
}

// Add a function to submit partner form data
export async function submitPartnerFormData(
  formId: number,
  formData: Record<string, any>
): Promise<{ success: boolean; id?: number; error?: string }> {
  // Reuse the existing form submission function from getForms.ts
  try {
    // Transform form data if needed to match expected format
    const processedData = { ...formData };

    // Handle files if present (similar to how it's done in Forms.tsx)
    Object.keys(processedData).forEach((key) => {
      if (processedData[key] instanceof File) {
        // For real file uploads, you'd need to handle file uploads separately
        processedData[key] = (processedData[key] as File).name;
      }
    });

    // Use the existing form submission function
    return await submitFormData(formId, processedData);
  } catch (error) {
    console.error("Error submitting partner form:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Failed to submit form",
    };
  }
}
